import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/submission/${number | ':submissionId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/submission/:submissionId`;

export const URL = (submissionId: number): RouteDefinition => `${baseRoute}/submission/${submissionId}`;
